import type { ReactNode } from 'react';

const getBoldText = () => {
  const BoldText = (chunks: ReactNode) => <b>{chunks}</b>;

  return BoldText;
};

const getItalicText = () => {
  const ItalicText = (chunks: ReactNode) => <i>{chunks}</i>;

  return ItalicText;
};

const getLink = (href: string, isExternal = false) => {
  const Link = (chunks: ReactNode) => <a href={href}>{chunks}</a>;

  const ExternalLink = (chunks: ReactNode) => (
    <a href={href} target="_blank" rel="noreferrer">
      {chunks}
    </a>
  );

  return isExternal ? ExternalLink : Link;
};

const getDownloadLink = ({ href, isMobile, onClick }: { href: string; isMobile: boolean; onClick: () => void }) => {
  const Link = (chunk: ReactNode) => (
    <a href={href} target={isMobile ? '_blank' : '_self'} rel="noreferrer" onClick={onClick}>
      {chunk}
    </a>
  );

  return Link;
};

const getLineBreak = () => {
  const LineBreak = () => <br />;

  return LineBreak;
};

export { getBoldText, getItalicText, getLink, getDownloadLink, getLineBreak };
